import { Box } from "@mui/material";
import {
  BOTTOM_MENU_HEIGHT,
  BottomMenu,
} from "Components/Layout/Menu/BottomMenu";
import { type ReactNode, useEffect } from "react";
import { useResource, Resources } from "Translations/Resources";
import mobileBg from "Assets/Images/Images/mobile-bg.png";

// TODO (nice to have)
// Maybe in the future the AuthenticatedLayout component could be refactored to be easier to customize, instead of creating new custom layout like below.
// I duplicated the AuthenticatedLayout here and simplified/changed it to fit my needs (flex-end content, no loyalty points, no top margin,...)

type Props = {
  title: string;
  children: ReactNode;
};

export const SimpleMobileLayout = ({ children, title }: Props) => {
  const { t } = useResource();

  useEffect(() => {
    document.title = `${title} | ${t(Resources.Common.AppName)}`;
  }, [t, title]);

  return (
    <>
      <Box overflow="hidden" display="flex" paddingBottom={BOTTOM_MENU_HEIGHT}>
        <Box
          sx={{
            top: 0,
            zIndex: "1",
            width: "100%",
            position: "absolute",
            minWidth: "350px",
            height: "400px",
          }}
        >
          <img
            src={mobileBg}
            alt=""
            aria-hidden
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </Box>
        <Box
          position="relative"
          display="flex"
          flexDirection="column"
          width="100%"
          zIndex={2}
          justifyContent="flex-end"
          padding={({ spacing }) => spacing(6, 3)}
        >
          <Box display="flex" justifyContent="center" width="100%">
            {children}
          </Box>
        </Box>
      </Box>
      <BottomMenu />
    </>
  );
};
